export default function (Highcharts) {
    Highcharts.dateFormats = {
        // negyedévek számmal
        q: function (timestamp) {
            var date = new Date(timestamp), quarter = Math.floor(date.getUTCMonth() / 3);
            return (quarter + 1).toString();
        },
        // negyedévek római számmal
        Q: function (timestamp) {
            var date = new Date(timestamp), quarter = Math.floor(date.getUTCMonth() / 3), roman = ['I', 'II', 'III', 'IV'];
            return roman[quarter];
        },
        //todo: leírást adni ennek
        // todo: mi a különbség az `r` és `R` a Jú és Ju hónapneveken kívül?
        r: function (timestamp) {
            var date = new Date(timestamp), quarter = Math.floor(date.getUTCMonth() / 3), months = ['J-M', 'Á-Jú', 'Jl-Sz', 'O-D'];
            return months[quarter];
        },
        //todo: leírást adni ennek
        R: function (timestamp) {
            var date = new Date(timestamp), quarter = Math.floor(date.getUTCMonth() / 3), months = ['J-M', 'Á-Ju', 'Jl-S', 'O-D'];
            return months[quarter];
        }
    };
}
;
